/**
* Hide/ Extend the Option from Customily Products in the shopping Cart
**/

// get all 'cart-item__details' classes
let cartDetails = document.querySelectorAll('.cart-item__details');

// loop through each cartDetails
cartDetails.forEach(cartDetail => {
  // select the 'dl' inside the current cartDetail
  let optionSets = cartDetail.querySelector('dl');
  let productOptions = optionSets.querySelectorAll('.product-option');

  // check if there's more than two divs
  if (productOptions.length > 2) {

    // create a new div
    var optionsCollapse = document.createElement('div');
    
    let spanNode = document.createElement('span');
    let html = 'mehr....';
    spanNode.classList.add('c_options-collapse-link');
    spanNode.innerHTML = html;
    
    // productOptions[1].parentNode.insertBefore(spanNode, productOptions[1].nextSibling);

    // Add a class to the optionsCollapse div to style or locate it easily
    optionsCollapse.classList.add('product-option-collapse');

    // Add style 'display: none' to the optionsCollapse div
    optionsCollapse.style.display = 'none';

    // start looping from the 3rd div and move (append) each to the new div
    Array.from(productOptions).slice(2).forEach(div => optionsCollapse.appendChild(div));

    // append the newly created div containing the rest of the original divs to the parent
    optionSets.appendChild(optionsCollapse);
    optionSets.appendChild(spanNode);
  }
});

var collapseLink = document.getElementsByClassName('c_options-collapse-link');

for (var i = 0; i < collapseLink.length; i++) {
collapseLink[i].addEventListener('click', function() {
  
   if (this.previousElementSibling.style.display === 'none') {
      this.previousElementSibling.style.display = 'contents';
      this.innerHTML = 'weniger....'; // changes the text to 'Weniger'
    } else {
      this.previousElementSibling.style.display = 'none';
      this.innerHTML = 'mehr....'; // changes the text back to 'Weiter....'
    }
});
}

Shopify.onCartUpdate = function(cart) {
  alert('There are now ' + cart.item_count + ' items in the cart.');
};  


var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener nofollow';
  }
}

//Video Container Start
var video_containers = document.getElementsByClassName('go_video_container');

for (i=0; i<video_containers.length; i++) {
	let container = video_containers[i];
	let button = document.createElement('button');
	button.innerText = '▶';
	button.addEventListener(
		'click', (e) => showVideo(container.id)
	);
	container.append(button);
	
	let modal = document.createElement('div');
	modal.classList.add('go_video_modal');
	modal.id = 'go_video_modal_'+container.id;
	
	let modal_buttons = document.createElement('div');
	modal_buttons.classList.add('go_video_modal_buttons');
	modal_buttons.id = 'go_video_modal_buttons_'+container.id;
	
	let close_button = document.createElement('button');
	close_button.innerText = 'X';
	close_button.addEventListener(
		'click', (e) => hideVideo(container.id)
	);
	modal_buttons.append(close_button);
	
	let modal_content = document.createElement('div');
	modal_content.classList.add('go_video_modal_content');
	modal_content.id = 'go_video_modal_content_'+container.id;
	
	modal.append(modal_buttons);
	modal.append(modal_content);
	
	document.body.append(modal);
}

function showVideo(video_id) {
    console.log("showVideo");
	let modal = document.getElementById('go_video_modal_'+video_id);
    console.log("MOdal: ", modal);
	let modal_content = document.getElementById('go_video_modal_content_'+video_id);
	
	if (video_id.length < 13) {
		var content = document.createElement('iframe');
		content.src = 'https://www.youtube.com/embed/'+video_id+'?autoplay=1';
		content.setAttribute('frameborder',0);
		content.setAttribute('allowfullscreen','');
	} else {
		var content = document.createElement('video');
		content.setAttribute('controls','');
		content.setAttribute('autoplay','');
		let source = document.createElement('source');
		source.src = 'https://wgeschankaonline.com/media/video/'+video_id;
		content.append(source);
	}
	
	modal_content.append(content);
    console.log("Content: ", content);
	modal.style.display = 'block';
}
function hideVideo(video_id) {
	let modal = document.getElementById('go_video_modal_'+video_id);
	let modal_content = document.getElementById('go_video_modal_content_'+video_id);
	modal.style.display = 'none';
	modal_content.innerHTML = '';
}

//Video Container End

//Spiele Videos in Vorschaubildern beim Hover Automatisch ab
/*document.addEventListener('DOMContentLoaded', function() {
  
  const thumbnails = document.querySelectorAll('.thumbnail-list__item, .product__media-item');
  
  thumbnails.forEach(thumbnail => {
    const link = thumbnail.querySelector('a, button');
    const video = thumbnail.querySelector('video');
    
    if (video && link) {
      video.muted = true;
      video.loop = true;
      
      thumbnail.addEventListener('mouseenter', () => {
        video.play();
      });
      
      thumbnail.addEventListener('mouseleave', () => {
        video.pause();
        video.currentTime = 0;
      });
    }
  });
  
  // Für das Haupt-Produktbild/-video
  const mainMedia = document.querySelector('.product__media-wrapper, .product__modal-opener');
  if (mainMedia) {
    const video = mainMedia.querySelector('video');
    if (video) {
      video.muted = true;
      
      mainMedia.addEventListener('mouseenter', () => {
        video.play();
      });
      
      mainMedia.addEventListener('mouseleave', () => {
        video.pause();
      });
    }
  }
});*/

